import { StatePreV9, StateV9 } from './9_migrate_uw_toolbar_flags.interface';

export const migrateUwToolbarFlags = (previousState: StatePreV9, newVersion: number): StateV9 => {
  const migratedState: StatePreV9 = { ...previousState };
  delete migratedState.isAnfragepflichtigeInformationen;
  delete migratedState.isTransferToAgentPage;
  delete migratedState.uwReviewBlocksEditing;
  return { ...migratedState, version: newVersion } as StateV9;
};
